// import React from "react";
import "../style/Footer.css"; 
import { Link } from "react-router-dom";
import React, { useState } from "react";
import { Mail, Phone, FileText } from "lucide-react"; 

const Footer = () => {

    const [file, setFile] = useState(null);

    const handleSubmit = (e) => {
        e.preventDefault();
        alert("Form submitted!");
    };

  return (
    <footer>
      <div className="footer-container">

    
        <div className="footer-section">
          <h3>Get in Touch</h3>
          <p>
            BF 9-12, Krishna Complex, Opp. Essar Petrol Pump, Yellow Lime Hotel
            Complex, Sarkhej Sanand Road, Sarkhej, Ahmedabad-382210.
          </p>
         
          <a href="mailto:inquiry@a-okmotorindia.com" style={{ color: '#fff', textDecoration: 'none' }}>
            inquiry@a-okmotorindia.com
          </a>

         
          <a href="tel:+917942963398" style={{ color: '#fff', textDecoration: 'none' }}>
            +91 7942963398
          </a>

        </div>

   
        <div className="footer-section">
          <h3>Quick Links</h3>
          <Link to="/">Home</Link>
          <Link to="/About">About Us</Link>
          <Link to="/Product">Our Product</Link>
          {/* <a href="/Solution">Solution</a> */}
          <Link to="/FAQs">FAQs</Link>
          <Link to="/Career">Career</Link>
          <Link to="/Contact">Contact</Link>
        </div>

        {/* Social Media */}
        <div className="footer-section">
          <h3>Social Media</h3>
          <div className="social-icons">
            <a href="https://www.facebook.com/aokmotorsindia" target="_blank" rel="noreferrer">
              <img src="/icons/facebook.png" alt="Facebook" />
            </a>
            <a href="https://www.instagram.com/aokmotorsindia" target="_blank" rel="noreferrer">
              <img src="/icons/instagram.png" alt="Instagram" />
            </a>
            <a href="https://www.linkedin.com/company/104599617" target="_blank" rel="noreferrer">
              <img src="/icons/linkedin.png" alt="LinkedIn" />
            </a>
            <a href="https://youtube.com/@aokmotorsindia?si=j5b7Sn7qHXlEaZ9v" target="_blank" rel="noreferrer">
              <img src="/icons/youtube.png" alt="YouTube" />
            </a>
          </div>
        </div>


            
         

      </div>

   
      <div className="bottom">
        © 2025-26 A-OK Motors. All Rights Reserved. Powered by{" "}
        <a href="https://growaplan.com" >
          Growaplan
        </a>
      </div>





    </footer>
  );
};

export default Footer;
